import React, { useState } from 'react';
import FormError from '../../../../FormError';

export default function ChipList({
    testId, label, values, onChange, errors = {}, field = null, hint = null,
    formatDraft = (value) => value,
    normalize = (value) => value,
}) {
    const [draft, setDraft] = useState('');
    const inputId = `${testId}-input`;
    const listError = field ? errors[field]?.[0] : null;

    const addChip = () => {
        const trimmed = draft.trim();
        const key = normalize(trimmed);
        if (!trimmed || values.some((existing) => normalize(existing) === key)) {
            return;
        }
        onChange([...values, trimmed]);
        setDraft('');
    };

    const removeChip = (value) => {
        onChange(values.filter((existing) => existing !== value));
    };

    return (
        <div data-testid={testId}>
            <label htmlFor={inputId}>{label}</label>
            {hint &&
                <span className="demo-island-optional demo-island-chip-hint">{hint}</span>
            }
            <div className="input-group demo-island-chip-input">
                <input
                    id={inputId}
                    type="text"
                    className="form-control"
                    value={draft}
                    onChange={(event) => setDraft(formatDraft(event.target.value, draft))}
                />
                <div className="input-group-append">
                    <button type="button" className="btn btn-secondary" onClick={addChip}>
                        {__('Add')}
                    </button>
                </div>
            </div>
            <FormError error_message={listError} />
            <ul className="demo-island-chip-list">
                {values.map((value, index) => (
                    <li key={value} className="demo-island-chip-item">
                        <span className="demo-island-chip">
                            <span className="demo-island-chip-label">{value}</span>
                            <button
                                type="button"
                                className="demo-island-chip-remove"
                                aria-label={`${__('Remove')} ${value}`}
                                onClick={() => removeChip(value)}
                            >
                                &times;
                            </button>
                        </span>
                        <FormError error_message={field ? errors[`${field}.${index}`]?.[0] : null} />
                    </li>
                ))}
            </ul>
        </div>
    );
}
